import styled from 'styled-components';
import Box from '..';

export const Row = styled(Box)`
  display: flex;
  flex-direction: row;
`;